/**
 * @generated SignedSource<<64493b094330d5c0cfcac3c78d89cff3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type asanaStreamDetails$data = {
  readonly asanaProject: {
    readonly externalId: string | null;
    readonly name: string;
    readonly type: string | null;
    readonly workspaceExternalId: string | null;
  };
  readonly createdBy: {
    readonly fullName: string;
  };
  readonly includeAiGenerated: boolean;
  readonly " $fragmentType": "asanaStreamDetails";
};
export type asanaStreamDetails$key = {
  readonly " $data"?: asanaStreamDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"asanaStreamDetails">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "asanaStreamDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AsanaProjectNode",
      "kind": "LinkedField",
      "name": "asanaProject",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workspaceExternalId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeAiGenerated",
      "storageKey": null
    }
  ],
  "type": "AsanaStreamNode",
  "abstractKey": null
};

(node as any).hash = "cffecc57a28ab7239776d95ef5e044c8";

export default node;
